import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue, push, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { toast } from 'react-toastify';

const LEGeneCertificate = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [userData, setUserData] = useState({
        qualification: '',
        address: '',
        amount: '',
        regClass: '',
        term: '',
        eligibility: '',
        regNo: ''
    });

    useEffect(() => {
        // Fetch users who are approved for limit expansion
        const usersRef = ref(db, 'ekamwatapzp/LimitExpandApplications');
        onValue(usersRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const approvedUsers = Object.keys(data)
                    .map(key => ({ id: key, ...data[key] }))
                    .filter(user => user.status === 'Approved');
                setUsers(approvedUsers);
            }
        });
    }, []);

    const handleUserChange = (e) => {
        const userId = e.target.value;
        setSelectedUser(userId);
        const user = users.find(u => u.id === userId);
        if (user) {
            setUserData({
                ...userData,
                qualification: user.qualification || '',
                address: user.address || '',
                amount: user.amount || '3000000.00', // Example amount for LE
                regClass: user.regClass || 'वर्ग - ४ (अ)',
                eligibility: user.eligibility || '३०.०० लाखापर्यंतची कामे (मयाद वाढवुन)'
            });
        }
    };

    const handleSubmit = () => {
        if (!selectedUser || !userData.regNo || !userData.term) {
            toast.error("कृपया सर्व अनिवार्य शेत भरा.");
            return;
        }

        const certRef = ref(db, 'ekamwatapzp/GeneratedLECertificates');
        const newCertRef = push(certRef);
        set(newCertRef, {
            ...userData,
            userId: selectedUser,
            applicantName: users.find(u => u.id === selectedUser)?.applicantName,
            generateDate: new Date().toLocaleDateString(),
            timestamp: Date.now()
        }).then(() => {
            toast.success("प्रमाणपत्र यशस्वीरित्या तयार झाले!");
            navigate('/main-update-le-status');
        });
    };

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col  p-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
                    <h1 className="text-xl font-medium text-gray-700">प्रमाणपत्र तयार करा</h1>
                    <div className="flex items-center text-sm font-medium text-gray-400 gap-2">
                        <span>जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-500 font-semibold">प्रमाणपत्र तयार करा</span>
                    </div>
                </div>

                {/* Form Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-10 max-w-[1400px]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">

                        {/* Select User */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Select User (वापरकर्ता निवडा) <span className="text-red-500">*</span></label>
                            <select
                                value={selectedUser}
                                onChange={handleUserChange}
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm outline-none focus:border-blue-400 text-gray-500 bg-white"
                            >
                                <option value="">Select User</option>
                                {users.map(u => (
                                    <option key={u.id} value={u.id}>{u.applicantName}</option>
                                ))}
                            </select>
                        </div>

                        {/* Qualification */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Qualification (पात्रता)<span className="text-red-500">*</span></label>
                            <select
                                value={userData.qualification}
                                onChange={(e) => setUserData({ ...userData, qualification: e.target.value })}
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm outline-none focus:border-blue-400 text-gray-500 bg-white"
                            >
                                <option value="">Select Qualification</option>
                                <option value="Degree">Degree</option>
                                <option value="Diploma">Diploma</option>
                            </select>
                        </div>

                        {/* Address */}
                        <div className="flex flex-col gap-2 md:col-span-1">
                            <label className="text-sm font-bold text-gray-600">Address (पुर्ण पत्ता) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.address}
                                readOnly
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm bg-gray-50/50 outline-none cursor-default"
                            />
                        </div>

                        {/* Amount */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Amount (रक्कम) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.amount}
                                readOnly
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm bg-gray-50/50 outline-none cursor-default"
                            />
                        </div>

                        {/* Registration Class */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Registration class (नोंदणी वर्ग) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.regClass}
                                readOnly
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm bg-gray-50/50 outline-none cursor-default"
                            />
                        </div>

                        {/* Certificate Term */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Certificate term (प्रमाणपत्राची मुदत) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.term}
                                onChange={(e) => setUserData({ ...userData, term: e.target.value })}
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm outline-none focus:border-blue-400"
                            />
                        </div>

                        {/* Eligibility to work */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Eligibility to work (कामे करण्याची पात्रता) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.eligibility}
                                readOnly
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm bg-gray-50/50 outline-none cursor-default"
                            />
                        </div>

                        {/* Registration Number */}
                        <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-gray-600">Registration number (नोंदणी क्रमांक) <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={userData.regNo}
                                placeholder="For ex. 123/22"
                                onChange={(e) => setUserData({ ...userData, regNo: e.target.value })}
                                className="w-full border border-gray-200 rounded px-4 py-2 text-sm outline-none focus:border-blue-400"
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="pt-2">
                            <button
                                onClick={handleSubmit}
                                className="bg-[#5e72e4] hover:bg-[#4a5ed1] text-white px-8 py-2.5 rounded font-bold text-sm shadow-md transition-transform active:scale-95"
                            >
                                Submit
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default LEGeneCertificate;
